import {AnalyticsRoutesEnum} from 'interfaces'

import {openAnalyticsOverviewWithDopamineAssistant} from './featureHighlightActions'
import {FeatureHighlightMeta} from './types'

/**
 * Feature highlight campaigns, newest first.
 *
 * - **Index 0** is the live campaign (`ACTIVE_FEATURE_HIGHLIGHT`).
 * - **Index 1+** are retired campaigns kept for reference and known storage keys.
 * - When promoting a new feature, **prepend** its config; the previous index 0
 *   becomes index 1 (shift the rest). Do not remove retired entries.
 */
const FEATURE_HIGHLIGHTS: FeatureHighlightMeta[] = [
  {
    id: 'dopamine-assistant',
    storageKey: 'dopamine-assistant-feature-highlight-v1',
    i18nNamespace: 'common',
    titleKey: 'DOPAMINE_FEATURE_HIGHLIGHT_TITLE',
    messageKey: 'DOPAMINE_FEATURE_HIGHLIGHT_MESSAGE',
    ctaLabelKey: 'DOPAMINE_FEATURE_HIGHLIGHT_CTA',
    skipLabelKey: 'DOPAMINE_FEATURE_HIGHLIGHT_SKIP',
    eyebrowKey: 'DOPAMINE_FEATURE_HIGHLIGHT_EYEBROW',
    onAccept: openAnalyticsOverviewWithDopamineAssistant,
    requiresAdmin: true,
    requiresAnalyticsTenantAccess: true,
    requiresDopamineAssistantAvailable: true,
  },
  {
    id: 'ai-usage',
    storageKey: 'ai-usage-feature-highlight-v1',
    i18nNamespace: 'aiUsage',
    titleKey: 'FEATURE_HIGHLIGHT_TITLE',
    messageKey: 'FEATURE_HIGHLIGHT_MESSAGE',
    ctaLabelKey: 'FEATURE_HIGHLIGHT_CTA',
    skipLabelKey: 'FEATURE_HIGHLIGHT_SKIP',
    eyebrowKey: 'FEATURE_HIGHLIGHT_EYEBROW',
    targetPath: AnalyticsRoutesEnum.ANALYTICS_AI_USAGE_APPS,
    routeMatch: AnalyticsRoutesEnum.ANALYTICS_AI_USAGE,
    requiresAdmin: true,
    requiresAnalyticsTenantAccess: true,
  },
]

/** Active campaign; always `FEATURE_HIGHLIGHTS[0]`. This is the only public export. */
export const ACTIVE_FEATURE_HIGHLIGHT: FeatureHighlightMeta =
  FEATURE_HIGHLIGHTS[0]

/** Storage keys for active and retired campaigns (orphan cleanup in storage.ts). */
export const getKnownFeatureHighlightStorageKeys = (): readonly string[] =>
  FEATURE_HIGHLIGHTS.map(feature => feature.storageKey)
